import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { TextStyle } from "pixi.js";

export class NewsTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 36,
            lineHeight: 43.2,
            fill: '#FFFFFF',
            dropShadow: true,
            dropShadowAlpha: 0.4,
            dropShadowAngle: 0.7,
            dropShadowBlur: 5,
            dropShadowColor: '#0D06064D',
            dropShadowDistance: 3
        })
    }
}